"use client";

import { useFormStatus } from "react-dom";

function GoogleG() {
  return (
    <svg viewBox="0 0 18 18" aria-hidden="true" className="google-g">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.71-1.57 2.68-3.89 2.68-6.62Z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18Z" />
      <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33Z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 9 0 9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58Z" />
    </svg>
  );
}

/**
 * The Google submit, split out of `page.tsx` only so it can read `useFormStatus`
 * (which sees the NEAREST ENCLOSING <form>, so it must be a child of it). The
 * page stays a server component and keeps owning the server action.
 *
 * Busy state is the app's ActionButton convention, the same one the password
 * form's "Sign in" wears: disabled + `aria-busy`, the label dims in place and the
 * gold ✦ pulses over it. The label never changes, so the button never reflows.
 * The action redirects to Google on success; if it throws, the route's error
 * boundary renders, so the press never ends in silence.
 */
export function GoogleSubmit() {
  const { pending } = useFormStatus();
  return (
    <button
      type="submit"
      className={pending ? "btn auth-google is-busy" : "btn auth-google"}
      disabled={pending}
      aria-busy={pending || undefined}
    >
      <span className="busy-inner">
        <GoogleG />
        Continue with Google
      </span>
      {pending ? <span className="busy-star" aria-hidden="true">✦</span> : null}
    </button>
  );
}
